export default __webpack_public_path__ + "static/award-badge-9498f7b83aee8306fb4010ceb8f18f28.svg";